<template>
  <div>
    <form>
      <!-- begin invoice -->
      <div class="invoice">
        <!-- begin invoice-content -->
        <div class="invoice-content">
          <!-- begin invoice-price -->
          <div class="invoice-price">
            <div class="invoice-price-left">
              <div class="invoice-price-row" style="width: 100%">
                <div class="sub-price" style="width: 30%; margin-top: -8px">
                  <small>{{ $t('martSale.subtotal') }}</small>
                  <span class="text-inverse">{{ defaultCrrency }}
                    {{ data ? data.sub_total : 0 | format_number }}</span>
                </div>
                <div class="sub-price text-center" style="width: 170px">
                  <small>{{ $t('martSale.discount') }}</small>
                  <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                      <input type="radio" v-model="model.discount_type" id="dolar" :value="'$'" />
                      &nbsp;$
                    </b-input-group-prepend>
                    <b-form-input v-model.number="model.discount_rate" class="text-center"
                      @input="calculate"></b-form-input>
                    <b-input-group-prepend is-text for="percentage">
                      <input type="radio" v-model="model.discount_type" id="percentage" :value="'%'" />
                      &nbsp;%
                    </b-input-group-prepend>
                  </b-input-group>
                </div>
                <div class="sub-price text-right" style="width: 35%; margin-top: -8px">
                  <small>{{ $t('martSale.vat') }}
                    {{ vatRate ? '(' + vatRate + '%)' : '' }}</small>
                  <span class="text-inverse">
                    {{ defaultCrrency }}
                    {{ model.vat_amount | format_number }}</span>
                </div>
              </div>
            </div>
            <div class="invoice-price-right" style="background: #808b96">
              <small>{{ $t('martSale.total') }}</small>
              <span class="f-w-600">{{ defaultCrrency }}
                {{ model.grand_total | format_number }}</span>
            </div>
          </div>
          <br />
          <div class="payment">
            <label class="col-form-label">
              {{ $t('martSale.cashPayment') }}</label>
            <div class="invoice-price">
              <div class="invoice-price-left">
                <div class="form__group field">
                  <input ref="paid_in_default_currency" type="number" class="form__field"
                    :placeholder="$t('martSale.cashPayment') + defaultCrrency" v-model.number="paid_in_default_currency"
                    min="0" @input="calculate" required />
                  <label for="name" class="form__label">
                    {{ $t('martSale.cashIn') }}
                    {{ defaultCrrency }}</label>
                </div>
              </div>
              <div class="invoice-price-right">
                <span class="f-w-600 text-success" :class="{ 'text-danger': change_in_default_currency < 0 }">{{
                  defaultCrrency }}
                  {{ change_in_default_currency | format_number }}</span>
              </div>
            </div>
            <div class="invoice-price">
              <div class="invoice-price-left">
                <div class="form__group field">
                  <input type="number" class="form__field" :placeholder="$t('martSale.cashPayment') + toCurrency"
                    v-model.number="paid_in_to_currency" min="0" @input="calculate" required />
                  <label for="name" class="form__label">
                    {{ $t('martSale.cashIn') }} {{ toCurrency }}</label>
                </div>
              </div>
              <div class="invoice-price-right">
                <span class="f-w-600 text-success" :class="{ 'text-danger': change_in_to_currency < 0 }">{{ toCurrency
                }}
                  {{ change_in_to_currency | format_number }}</span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">+ {{ $t('martSale.otherPayment') }}</label>
              <div class="col-md-5">
                <ul class="list-inline payment-type">
                  <li :class="{ active: isActive == 'coupon' }">
                    <a href="#" :title="$t('martSale.coupon')" @click="
                        ;[
                      (isActive = 'coupon'),
                      (model.paid_in_credit_card = null),
                      (model.payment_method_id = 1)
                    ]
                    onPaymentMethodChange()
                      "><i class="fab fa-contao"></i></a>
                  </li>
                  <li :class="{ active: isActive == 'credit_card' }">
                    <a href="#" :title="$t('martSale.creditCard')" @click="
                        ;[
                      (isActive = 'credit_card'),
                      (model.paid_in_coupon = null),
                      (model.payment_method_id = 4)
                    ]
                    onPaymentMethodChange()
                      ">
                      <i class="far fa-credit-card"></i>
                    </a>
                  </li>
                  <li :class="{ active: isActive == 'bank_transfer' }">
                    <a href="#" :title="$t('martSale.bankTransfer')" @click="
                        ;[
                      (isActive = 'bank_transfer'),
                      (model.bank_transfer = null),
                      (model.payment_method_id = 3)
                    ]
                    onPaymentMethodChange()
                      ">
                      <i class="fa fa-university"></i>
                    </a>
                  </li>
                  <li :class="{ active: isActive == 'paid_by_cheque' }">
                    <a href="#" :title="$t('martSale.paidByCheque')" @click="
                        ;[
                      (isActive = 'paid_by_cheque'),
                      (model.paid_by_cheque = null),
                      (model.payment_method_id = 2)
                    ]
                    onPaymentMethodChange()
                      ">
                      <i class="fas fa-money-check-alt"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <!-- Bank info -->
                <div class="invoice-price" v-if="isActive != 'coupon'">
                  <div class="invoice-price-left">
                    <a-input-group compact>
                      <a-input v-model="model.bank_name" style="width: 23%; font-weight: 800; text-align: center"
                        disabled />
                      <a-input v-model="bankAccountNumber" style="width: 77%; font-weight: 800" disabled />
                    </a-input-group>
                    <div class="validate" v-if="errors.has('account_name')">
                      {{ errors.first('bank_name') }}
                    </div>
                  </div>
                  <div class="invoice-price-right-gray"></div>
                </div>

                <!-- coupon -->
                <div class="invoice-price" v-if="isActive == 'coupon'">
                  <div class="invoice-price-left">
                    <div class="form__group field">
                      <input type="number" class="form__field" :placeholder="$t('martSale.couponInUsd')" min="0"
                        v-model.number="model.paid_in_coupon" @input="calculate" required />
                      <label for="name" class="form__label">
                        {{ $t('martSale.couponInUsd') }}
                      </label>
                    </div>
                  </div>
                  <div class="invoice-price-right-gray">
                    <div class="ts-w-full mt-1">
                      <a-alert v-if="changeInUsdErrors.length > 0" message="Payment" :description="changeInUsdErrors[0]"
                        type="error" show-icon closable />
                    </div>
                  </div>
                </div>

                <!-- credit_card -->
                <div class="invoice-price" v-if="isActive == 'credit_card'">
                  <div class="invoice-price-left">
                    <div class="form__group field">
                      <input type="number" class="form__field" :placeholder="$t('martSale.creditCardInUsd')" min="0"
                        v-model.number="model.paid_in_credit_card" @input="calculate" required />
                      <label for="name" class="form__label">
                        {{ $t('martSale.creditCardInUsd') }}
                      </label>
                    </div>
                  </div>
                  <div class="invoice-price-right-gray">
                    <div class="ts-w-full mt-1">
                      <a-alert v-if="changeInUsdErrors.length > 0" message="Payment" :description="changeInUsdErrors[0]"
                        type="error" show-icon closable />
                    </div>
                  </div>
                </div>

                <!-- bank_transfer -->
                <div class="invoice-price" v-if="isActive == 'bank_transfer'">
                  <div class="invoice-price-left">
                    <div class="form__group field">
                      <input type="number" class="form__field" :placeholder="$t('martSale.bankTransferInUsd')" min="0"
                        v-model.number="model.bank_transfer" @input="calculate" required />
                      <label for="name" class="form__label">
                        {{ $t('martSale.bankTransferInUsd') }}
                      </label>
                    </div>
                    <div class="form__group field">
                      <input type="number" class="form__field" :placeholder="$t('martSale.bankTransferInRiel')" min="0"
                        v-model.number="model.bank_transfer_riel" @input="calculate" required />
                      <label for="name" class="form__label">
                        {{ $t('martSale.bankTransferInRiel') }}
                      </label>
                    </div>
                  </div>
                  <div class="invoice-price-right-gray">
                    <div class="ts-w-full mt-1">
                      <a-alert v-if="changeInUsdErrors.length > 0" message="Payment" :description="changeInUsdErrors[0]"
                        type="error" show-icon closable />
                    </div>
                  </div>
                </div>

                <!-- paid_by_cheque -->
                <div class="invoice-price" v-if="isActive == 'paid_by_cheque'">
                  <div class="invoice-price-left">
                    <div class="form__group field">
                      <input type="number" class="form__field" :placeholder="$t('martSale.paidByChequeInUsd')" min="0"
                        v-model.number="model.paid_by_cheque" @input="calculate" required />
                      <label for="name" class="form__label">
                        {{ $t('martSale.paidByChequeInUsd') }}
                      </label>
                    </div>
                  </div>
                  <div class="invoice-price-right-gray">
                    <div class="ts-w-full mt-1">
                      <a-alert v-if="changeInUsdErrors.length > 0" message="Payment" :description="changeInUsdErrors[0]"
                        type="error" show-icon closable />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end invoice-content -->
      </div>
      <!-- end invoice -->
      <!-- begin invoice-footer -->
      <div class="invoice-footer">
        <div class="row">
          <div class="col-lg-6">
            <div style="padding-left: 20px">
              <ts-checkbox v-model="model.is_city_ledger">{{
                $t('martSale.cityLedger')
              }}</ts-checkbox>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="btn-row pull-right">
              <ts-button class="btn btn-default" :disabled="waiting" @click="$emit('close')">
                {{ $t('cancel') }}</ts-button>
              <ts-button type="submit" @click.prevent="bill" :waiting="waiting" class="btn btn-success btn-lg"><i
                  v-if="!waiting" class="fas fa-check fa-fw fa-lg"></i>
                {{ $t('martSale.bill') }}</ts-button>
            </div>
          </div>
        </div>
      </div>
      <!-- end invoice-footer -->
    </form>
    <a-modal width="500px" v-model="show_bank" centered :title="titleName" :maskClosable="false" :okText="$t('confirm')"
      :cancelText="$t('cancel')" :cancelButtonProps="{ class: 'btn ts-whitespace-no-wrap btn-default' }"
      style="top: 3vh" :zIndex="1040" :closable="false" @cancel="onCanel" @ok="onOk">
      <div>
        <div class="row">
          <label class="required col-lg-12">{{ $t('wholesale.bank') }}</label>
          <a-radio-group v-model="model.bank_name" @change="bankNameChange" class="col-lg-12" size="large">
            <a-radio-button v-for="(record, index) in bankNameOptions" :key="index" :value="record.label">{{
              record.label }}</a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div>
        <div class="row">
          <label class="required col-lg-12">{{
            $t('wholesale.account')
          }}</label>
          <a-radio-group v-model="model.account_number" @change="accountChange" class="col-lg-12" size="large">
            <a-radio-button v-for="(record, index) in accountOptions" :key="index" :value="record.value">{{ record.label
            }}</a-radio-button>
          </a-radio-group>
          <!-- <div class="col-lg-12" v-if="isShow([2])">
            <a-input v-model="model.account_name" />
          </div> -->
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { required, minValue } from 'vuelidate/lib/validators'
import Swal from 'sweetalert2'
import { mapActions } from 'vuex'

export default {
  name: 'checkBill',
  props: ['data'],
  data() {
    return {
      show_bank: false,
      model: {
        stock_out_id: null,
        customer_id: null,
        paid_in_riel: null,
        paid_in_usd: null,
        paid_in_coupon: null,
        paid_in_credit_card: null,
        change_in_riel: null,
        change_in_usd: null,
        sub_total: null,
        discount_type: '%',
        discount_rate: null,
        discount_amount: null,
        total_after_discount: null,
        vat_amount: null,
        grand_total: null,
        is_city_ledger: false,
        products: [],
        payment_method_id: 1,
        bank_name: null,
        account_number: null,
        account_name: null,
        bank_transfer: null,
        paid_by_cheque: null,
        bank_transfer_riel: null,
        ref_quotation_id: null
      },
      paid_in_default_currency: null,
      paid_in_to_currency: null,
      change_in_default_currency: 0,
      change_in_to_currency: 0,
      time: '00:00',
      waiting: false,
      isActive: 'coupon',
      paymentMethods: [],
      errors: new Errors(),
      bankProfiles: []
    }
  },
  validations: {
    model: {
      change_in_usd: { required, minValue: minValue(0) }
    }
  },
  created() {
    this.calculate()
    this.model.counter_id = parseInt(localStorage.getItem('counterId'))
    this.fetchResource()
  },

  mounted() {
    this.$refs.paid_in_default_currency.focus()
  },
  filters: {
    format_number(value) {
      return `${parseFloat(value).toLocaleString()}`
    }
  },
  computed: {
    isShow: vm => arrayValue => {
      return _.includes(arrayValue, vm.model.payment_method_id)
    },
    notDisableFor: vm => arrayValue => {
      return !_.includes(arrayValue, vm.model.payment_method_id)
    },
    vatRate() {
      return parseFloat(
        this.$store.state.martSale.order.systemSettings.vat_rate
      )
    },
    exchangeRate() {
      return parseFloat(this.$store.state.martSale.order.systemSettings.fx_rate)
    },
    defaultCrrency() {
      return this.$store.state.martSale.order.systemSettings.default_currency
    },
    toCurrency() {
      if (this.defaultCrrency == 'KHR') {
        return 'USD'
      }

      return 'KHR'
    },
    changeInUsdErrors() {
      const errors = []
      if (!this.$v.model.change_in_usd.$dirty) return errors
      !this.$v.model.change_in_usd.required && errors.push('Required')
      !this.$v.model.change_in_usd.minValue &&
        errors.push('Invalid payment amount.')
      return errors
    },
    paymentMethodOptions() {
      if (this.paymentMethods) {
        return this.paymentMethods.map(pm => ({
          value: pm.payment_method_id,
          label: pm.payment_method
        }))
      }
      return []
    },
    bankNameOptions() {
      return this.bankProfiles.map(el => ({
        value: el.bank_name,
        label: el.bank_name
      }))
    },
    accountOptions() {
      let acc = this.bankProfiles.filter(
        b => b.bank_name == this.model.bank_name
      )[0]
      if (acc) {
        return acc.accounts.map(el => ({
          value: el.account_number,
          label: el.account_number + '|' + el.account_name,
          name: el.account_name
        }))
      }
      return []
    },
    bankAccountNumber() {
      if (this.model.account_number && this.model.account_name) {
        return this.model.account_number + '|' + this.model.account_name
      }
      return ''
    },
    titleName() {
      switch (this.isActive) {
        case 'coupon':
          return 'Coupon'
        case 'credit_card':
          return 'Credit Card'
        case 'bank_transfer':
          return 'Bank Transfer'
        case 'paid_by_cheque':
          return 'Cheque'
      }
    }
  },
  methods: {
    ...mapActions('martSale/order', ['bankProfile', 'paymentMethod']),
    onCanel() {
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null
    },
    onOk() {
      this.show_bank = false
    },
    async onPaymentMethodChange(value) {
      this.model.paid_in_coupon = null
      this.model.paid_in_credit_card = null
      this.model.bank_transfer = null
      this.model.paid_by_cheque = null
      if (this.model.payment_method_id == 1) {
        this.model.bank_name = null
        this.model.account_number = null
        this.model.account_name = ''
      } else {
        this.show_bank = true
        this.model.bank_name = null
        this.model.account_number = null
        this.model.account_name = null
      }
      // await this.fetchBank()
      // if (this.model.payment_method_id != 1) {
      //   this.$emit('loading', true)
      //   this.bankProfile()
      //     .then(response => {
      //       this.bankProfiles = response.data
      //       this.show_bank = true
      //     })
      //     .catch(error => {
      //       this.$toasted.error(error.message)
      //     })
      //     .finally(() => {
      //       this.$emit('loading', false)
      //     })
      // } else {
      //   this.model.bank_name = null
      //   this.model.account_number = null
      //   this.model.account_name = null
      // }
    },
    fetchResource() {
      this.loading = true
      this.paymentMethod()
        .then(response => {
          this.paymentMethods = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
      this.fetchBank()
    },
    fetchBank() {
      // if (this.model.payment_method_id != 1) {
      this.$emit('loading', true)
      this.bankProfile()
        .then(response => {
          this.bankProfiles = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
      // }
      //  else {
      //   this.model.bank_name = null
      //   this.model.account_number = null
      //   this.model.account_name = null
      // }
    },
    bankNameChange() {
      this.model.account_number = null
      this.model.account_name = null
    },
    accountChange() {
      let account_name = this.accountOptions.find(
        el => el.value == this.model.account_number
      ).name
      this.model.account_name = account_name
      // this.model.account_name = opt.data.props.name
    },
    bill() {
      this.$v.$touch()
      if (this.$v.$error) return

      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'martSale/order/store',
          Object.assign({}, this.model, {
            counter_id: parseInt(localStorage.getItem('counterId')),
            action_type: 'check-bill'
          })
        )
        .then(response => {
          this.$emit('success')
          Swal.fire({
            title: 'CHECK BILL',
            icon: 'success',
            html:
              response.message +
              '<br /><b>' +
              this.$t('martSale.changeIn') +
              '<span class="text-success">' +
              this.defaultCrrency +
              ' ' +
              parseFloat(this.change_in_default_currency).toLocaleString() +
              '</span> => <span class="text-success">' +
              this.toCurrency +
              ' ' +
              parseFloat(this.change_in_to_currency).toLocaleString() +
              '</span></b>',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          if (this.errors.first('change_in_usd')) {
            this.$notification['error']({
              message: 'CHECK BILL',
              description: this.errors.first('change_in_usd'),
              placement: 'bottomRight'
            })
          } else {
            this.$notification['error']({
              message: 'CHECK BILL',
              description: error.message,
              placement: 'bottomRight'
            })
          }
        })
        .finally(() => {
          this.waiting = false
        })
    },

    calculate() {
      this.model.stock_out_id = this.data ? this.data.stock_out_id : null
      this.model.customer_id = this.data ? this.data.customer_id : null
      this.model.products = this.data ? this.data.products : []
      this.model.fx_rate = this.data ? this.data.fx_rate : 0
      this.model.vat_rate = this.data ? this.data.vat_rate : 0
      this.model.ref_quotation_id = this.data ? this.data.ref_quotation_id : null
      if (this.defaultCrrency == 'USD') {
        let paid_in_to_currency = 0
        let paid_in_coupon = 0
        let paid_in_credit_card = 0
        let bank_transfer = 0
        let bank_transfer_riel = 0
        let paid_by_cheque = 0
        let paid_in_default_currency = 0
        let discount_rate = 0
        paid_in_to_currency = _.round(
          this.paid_in_to_currency / this.exchangeRate,
          2
        )
        paid_in_coupon = _.round(this.model.paid_in_coupon, 2)
        paid_in_credit_card = _.round(this.model.paid_in_credit_card, 2)
        bank_transfer = _.round(this.model.bank_transfer, 2)
        bank_transfer_riel = _.round(
          this.model.bank_transfer_riel / this.exchangeRate,
          2
        )
        paid_by_cheque = _.round(this.model.paid_by_cheque, 2)
        paid_in_default_currency = _.round(this.paid_in_default_currency, 2)
        discount_rate = _.round(this.model.discount_rate, 2)
        this.model.sub_total = parseFloat(this.data ? this.data.sub_total : 0)
        this.model.discount_amount =
          this.model.discount_type == '$'
            ? discount_rate
            : (this.model.sub_total * discount_rate) / 100

        this.model.total_after_discount =
          this.model.sub_total - this.model.discount_amount
        this.model.vat_amount =
          (this.model.total_after_discount * this.vatRate) / 100
        this.model.grand_total =
          this.model.total_after_discount + this.model.vat_amount
        this.change_in_default_currency = _.round(
          paid_in_default_currency +
          paid_in_to_currency +
          paid_in_coupon +
          paid_in_credit_card +
          bank_transfer +
          bank_transfer_riel +
          paid_by_cheque -
          this.model.grand_total,
          2
        )
        this.change_in_to_currency = _.round(
          this.change_in_default_currency * this.exchangeRate,
          2
        )
        this.model.paid_in_usd = paid_in_default_currency
        this.model.paid_in_riel = this.paid_in_to_currency
        this.model.change_in_usd = this.change_in_default_currency
        this.model.change_in_riel = this.change_in_to_currency
      }
      if (this.defaultCrrency == 'KHR') {
        let paid_in_to_currency = 0
        let paid_in_coupon = 0
        let paid_in_credit_card = 0
        let bank_transfer = 0
        let bank_transfer_riel = 0
        let paid_by_cheque = 0
        let paid_in_default_currency = 0
        let discount_rate = 0
        paid_in_to_currency = _.round(
          this.paid_in_to_currency * this.exchangeRate,
          2
        )
        paid_in_coupon = _.round(
          this.model.paid_in_coupon * this.exchangeRate,
          2
        )
        paid_in_credit_card = _.round(
          this.model.paid_in_credit_card * this.exchangeRate,
          2
        )
        bank_transfer = _.round(this.model.bank_transfer * this.exchangeRate, 2)
        bank_transfer_riel = _.round(this.model.bank_transfer_riel, 2)
        paid_by_cheque = _.round(
          this.model.paid_by_cheque * this.exchangeRate,
          2
        )
        paid_in_default_currency = _.round(this.paid_in_default_currency, 2)
        discount_rate = _.round(this.model.discount_rate, 2)
        this.model.sub_total = parseFloat(this.data ? this.data.sub_total : 0)
        this.model.discount_amount =
          this.model.discount_type == '$'
            ? discount_rate * this.exchangeRate
            : (this.model.sub_total * discount_rate) / 100
        this.model.total_after_discount =
          this.model.sub_total - this.model.discount_amount
        this.model.vat_amount =
          (this.model.total_after_discount * this.vatRate) / 100
        this.model.grand_total =
          this.model.total_after_discount + this.model.vat_amount
        this.change_in_default_currency = _.round(
          paid_in_default_currency +
          paid_in_to_currency +
          paid_in_coupon +
          paid_in_credit_card +
          bank_transfer +
          bank_transfer_riel +
          paid_by_cheque -
          this.model.grand_total,
          2
        )
        this.change_in_to_currency = _.round(
          this.change_in_default_currency / this.exchangeRate,
          2
        )

        this.model.paid_in_riel = paid_in_default_currency
        this.model.paid_in_usd = this.paid_in_to_currency
        this.model.change_in_riel = this.change_in_default_currency
        this.model.change_in_usd = this.change_in_to_currency
      }
    }
  },
  watch: {
    isActive: {
      handler() {
        this.calculate()
      },
      deep: true
    },
    'model.discount_type': function (val) {
      if (val) {
        this.calculate()
      }
    }
  }
}
</script>
<style scoped>
.invoice {
  padding: 20px 20px 0 20px;
}

.invoice-header {
  padding: 1px;
}

.invoice .invoice-from {
  padding: 5px 20px;
}

.invoice .invoice-to {
  padding: 2px 20px;
}

.invoice .invoice-date {
  padding: 2px 20px;
}

.invoice>div:not(.invoice-footer) {
  margin-bottom: 10px;
}

.table>thead>tr>th,
.table>tbody>tr>th,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>tbody>tr>td,
.table>tfoot>tr>td {
  padding: 3px 5px;
}

.table-responsive {
  max-height: 15vh;
  overflow-x: scroll;
  overflow-y: scroll;
}

.table>thead>tr>th {
  position: sticky;
  top: 0;
  background: rgba(230, 230, 230, 1);
  z-index: 10;
}

.invoice .invoice-price .invoice-price-left {
  padding: 2px 10px;
  font-size: 15px;
}

.invoice .invoice-price .invoice-price-right {
  padding: 10px 10px;
  font-size: 23px;
  min-width: 41%;
}

.widget-table-img {
  width: 100px;
  height: auto;
}

.payment-type {
  font-size: 2rem;
  margin: 0;
}

.payment-type>li.active a {
  color: #2d353c;
}

.payment-type>li a {
  color: #999;
}

.form-control-lg {
  background: #fffefe;
}

.payment {
  background: #f2f3f4;
  padding: 0 0 5px 5px;
}

.invoice-footer {
  padding-top: 0;
}

.btn-row .btn {
  padding: 15px 25px;
  font-size: 0.875rem;
  min-width: 100px;
  text-align: center;
  position: relative;
  border-radius: 0;
}

.invoice .invoice-price .invoice-price-left .invoice-price-row .sub-price {
  padding: 0 10px;
}

.invoice .invoice-price .invoice-price-right-gray {
  padding: 10px 10px;
  font-size: 23px;
  min-width: 41%;
  background: #f2f3f4;
}
</style>
